import Cookies from "js-cookie"

/** Prefijo propio del ERP (lutenteERP). Autos usa `lutenteautos_`; Tours usará `lutentetours_`. */
export const COOKIE_PREFIX = "lutenteERP_"

export const AUTH_COOKIE_KEYS = [
  "tenant",
  "tenantURL",
  "usuario",
  "idUsuario",
  "nombreUsuario",
  "rolUsuario",
]

const LEGACY_ALSO_CLEAR = ["token"]

/**
 * Prefijos anteriores del ERP general, en orden de preferencia.
 * `""` = cookies sin prefijo (pre-namespacing). `lutentegeneral_` = el prefijo
 * usado entre el commit 4c435b42 y el rename a `lutenteERP_` (2026-09-08).
 * Se migran y se limpian para que nadie pierda la sesión al actualizar.
 */
const LEGACY_PREFIXES = ["", "lutentegeneral_"]

const COOKIE_OPTS = { path: "/" }

export function namespacedCookieName(name) {
  return `${COOKIE_PREFIX}${name}`
}

function removeEveryVariant(name) {
  ;[COOKIE_PREFIX, ...LEGACY_PREFIXES].forEach((prefix) => {
    Cookies.remove(`${prefix}${name}`, COOKIE_OPTS)
    Cookies.remove(`${prefix}${name}`)
  })
}

export const erpCookies = {
  get(name) {
    const namespaced = Cookies.get(namespacedCookieName(name))
    if (namespaced != null && namespaced !== "") return namespaced
    return undefined
  },
  set(name, value, options = {}) {
    if (value == null || value === "") {
      erpCookies.remove(name)
      return
    }
    Cookies.set(namespacedCookieName(name), String(value), {
      ...COOKIE_OPTS,
      ...options,
    })
  },
  remove(name) {
    removeEveryVariant(name)
  },
}

/** Copia cookies de prefijos viejos y las borra para no contaminar otros ERP. */
export function migrateLegacyAuthCookies() {
  AUTH_COOKIE_KEYS.forEach((name) => {
    const namespaced = Cookies.get(namespacedCookieName(name))
    const legacy = LEGACY_PREFIXES.map((prefix) =>
      Cookies.get(`${prefix}${name}`)
    ).find((valor) => valor != null && valor !== "")

    if ((!namespaced || namespaced === "") && legacy) {
      Cookies.set(namespacedCookieName(name), legacy, {
        ...COOKIE_OPTS,
        expires: name === "tenantURL" ? 365 : 1,
      })
    }

    LEGACY_PREFIXES.forEach((prefix) => {
      Cookies.remove(`${prefix}${name}`, COOKIE_OPTS)
      Cookies.remove(`${prefix}${name}`)
    })
  })
  LEGACY_ALSO_CLEAR.forEach((name) => {
    LEGACY_PREFIXES.forEach((prefix) => {
      Cookies.remove(`${prefix}${name}`, COOKIE_OPTS)
      Cookies.remove(`${prefix}${name}`)
    })
  })
}

export function clearLegacyAuthCookies() {
  ;[...AUTH_COOKIE_KEYS, ...LEGACY_ALSO_CLEAR].forEach((name) => {
    LEGACY_PREFIXES.forEach((prefix) => {
      Cookies.remove(`${prefix}${name}`, COOKIE_OPTS)
      Cookies.remove(`${prefix}${name}`)
    })
  })
}
